import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

export interface Team {
  image: string;
  name: string;
  position: string;
}
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

@Component({
  standalone: false,
  selector: 'app-pricing-table',
  templateUrl: './pricing-table.component.html',
  styleUrl: './pricing-table.component.css'
})
export class PricingTableComponent {
  //Pricing Tables
  pricingPlans = [
    {
      icon: 'bi bi-rocket-takeoff',
      name: 'Basic',
      price: '$195.99',
      features: [
        { value: '15', text: 'Email Account', available: true },
        { value: '100GB', text: 'Space', available: true },
        { value: '1', text: 'Domain Name', available: true },
        { value: '500GB', text: 'Bandwidth', available: true },
        { value: '25', text: 'MySQL Databases', available: true },
        { value: 'Unlimited', text: 'Subdomains', available: false }
      ]
    },
    {
      icon: 'bi bi-diamond-half',
      name: 'Standard',
      price: '$195.99',
      features: [
        { value: '15', text: 'Email Account', available: true },
        { value: '100GB', text: 'Space', available: true },
        { value: '1', text: 'Domain Name', available: true },
        { value: '500GB', text: 'Bandwidth', available: true },
        { value: '25', text: 'MySQL Databases', available: true },
        { value: 'Unlimited', text: 'Subdomains', available: false }
      ]
    },
    {
      icon: 'bi bi-pie-chart-fill',
      name: 'Ultimate',
      price: '$195.99',
      features: [
        { value: '15', text: 'Email Account', available: true },
        { value: '100GB', text: 'Space', available: true },
        { value: '1', text: 'Domain Name', available: true },
        { value: '500GB', text: 'Bandwidth', available: true },
        { value: '25', text: 'MySQL Databases', available: true },
        { value: 'Unlimited', text: 'Subdomains', available: false }
      ]
    }
  ];

  // OWl Slider
  testimonialOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 3,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  testimonials = [
    {
      name: "Melina Walber",
      position: "manager@Chaos.io",
      image: "avatar-4.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Doris Campos",
      position: "founder@Chaos.io",
      image: "avatar-5.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Melina Walber",
      position: "manager@Chaos.io",
      image: "avatar-6.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      name: "Doris Campos",
      position: "founder@Chaos.io",
      image: "avatar-1.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    }
  ];

  //Footer
  socialLinks = [
    { icon: 'bi-facebook', url: '/' },
    { icon: 'bi-twitter-x', url: '/' },
    { icon: 'bi-pinterest', url: '/' },
    { icon: 'bi-dribbble', url: '/' }
  ];

  quickLinks = [
    { name: 'About Us', url: '/about-us' },
    { name: 'Services', url: '/services' },
    { name: 'Portfolio', url: '/portfolio-one' },
    { name: 'Blogs', url: '/blog-grid' },
    { name: 'Contact Us', url: '/contact' }
  ];

  recentPosts = [
    {
      image: 'assets/images/blogs/post-img-sm.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    },
    {
      image: 'assets/images/blogs/post-img-sm-2.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    }
  ];
  
  // Team
  teamMembers: Team[] = [
    {
      image: 'assets/images/team/team-01.jpg',
      name: 'James Brewer',
      position: 'Digital Designer'
    },
    {
      image: 'assets/images/team/team-02.jpg',
      name: 'Mesha Albert',
      position: 'Senior User Interface'
    },
    {
      image: 'assets/images/team/team-03.jpg',
      name: 'Arthur Stewart',
      position: 'Founder & CEO'
    },
    {
      image: 'assets/images/team/team-04.jpg',
      name: 'Eden Charles',
      position: 'Art Director'
    }
  ];
}
